<template>
  <div>
    <div class="header">
      <h1 class="page-title">消费月报</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="card_header clearfix">
        <div class="block">
          <span>选择日期</span>
          <el-date-picker
            v-model="value2"
            type="monthrange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>

          <button class="searchBtn" @click="selectconsume()">搜索</button>
        </div>

      </div>

      <div class="main">
        <div class="cardtou">
          <div class="one">
            <div class="one-cont">
              <span class="one-yuan">营业收入</span>
              <span class="one-money">{{tableData.mr1}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">第三方消费</span>
              <span class="one-money">{{tableData.mr2}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">余额消费</span>
              <span class="one-money">{{tableData.mr3}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">售后损失</span>
              <span class="one-money">{{-tableData.mr4}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">订单取消损失</span>
              <span class="one-money">{{-tableData.mr8}}</span>
            </div>
          </div>
          <div class="one">
            <div class="one-cont">
              <span class="one-yuan">帐户余额</span>
              <span class="one-money">{{tableData.mr11}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">月初余额</span>
              <span class="one-money">{{tableData.mr6}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">本月第三方充值</span>
              <span class="one-money">{{tableData.mr7}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">本月后台充值</span>
              <span class="one-money">{{tableData.mr17}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">全部订单取消转充值</span>
              <span class="one-money">{{tableData.mr8}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">余额支付</span>
              <span class="one-money">{{tableData.mr9}}</span>
            </div>
          </div>
          <div class="one">

            <div class="one-cont">
              <span class="one-yuan">第三方帐户余额</span>
              <span class="one-money">{{tableData.mr12}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">本月第三方充值</span>
              <span class="one-money">{{tableData.mr7}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">第三方订单消费</span>
              <span class="one-money">{{tableData.mr14}}</span>
            </div>
            <div class="one-cont">
              <span class="one-yuan">第三方订单取消转充值</span>
              <span class="one-money">{{tableData.mr15}}</span>
            </div>
          </div>

        </div>
      </div>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="totalNum"
      ></el-pagination>
    </el-card>

   <!-- <a
      :href="baseUrl + `/api/mine/consume/explode/1/uid/${uId}${mindate==''?'':`/mindate/${mindate}`}${maxdate==''?'':`/maxdate/${maxdate}`}${keywords==''?'':`/keywords/${keywords}`}`"
      id="exportTable"
      class="btn btn-default"
    >导出excel</a> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 时间
      value2: '',
      token: window.localStorage.getItem('token'),
      mindate: '',
      maxdate: '',
      page: 1,
      pickerOptions: {
        shortcuts: [

          {
            text: '当月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth())
              start.setDate(1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              start.setDate(1)
              end.setMonth(start.getMonth() + 1)
              end.setDate(0)
              picker.$emit('pick', [start, end])
            }
          }

        ]
      },
      tableData: [],
      totalNum: 0,
      totalPirce: 0.00,
      loading: true,
      keywords: '',
      uId: '',
      baseUrl: '',
      filter: {},
      op: {},
      account_type: { '1': '订单消费', '2': '售后退款', '3': '取消转充值', '5': '会员充值', '6': '充值赠送', '7': '后台充值' },
      billtype: { '1': '收入', '2': '支出' },
      orderstatus: { '1': '正常', '2': '售后', '3': '取消' },
      paytype: { '1': '余额支付', '2': '支付宝', '3': '微信', '5': '后台充值' }
    }
  },
  created() {
    const url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.uId = JSON.parse(u).id
    }
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryConcume()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    handleCurrentChange(value) {
      this.page = value
      this.queryConcume()
    },
    // 补0
    PrefixInteger(num, length) {
      return ('00000000' + num).substr(-length)
    },
    // 搜素
    selectconsume() {
      this.page = 1
      this.queryConcume()
    },
    // 时间
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    //   消费，明细
    async queryConcume() {
      this.loading = true
      let url = '/admin/newbill/order/monthlyreport?addtabs=1&offset=' + (this.page * 10 - 10) + '&limit=10'
      if (this.keywords) {
        url += '&search=' + this.keywords
      }
      if (this.mindate && this.maxdate) {
        url += '&filter={"user_id":"' + this.uId + '","createtime":"' + this.mindate + ' - ' + this.maxdate + '"}&op={"user_id":"in","createtime":"RANGE"}'
      } else {
        url += '&filter={"user_id":"' + this.uId + '"}&op={"user_id":"in"}'
      }
      const { data: res } = await this.$http.get(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
      this.loading = false
      this.tableData = res
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.cardtou {
  display: flex;
  justify-content: space-around;
  .one {
    width: 33%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
    opacity: 1;
    border-radius: 10px;
    img {
      width: 96px;
      height: 96px;
      margin-left: 20px;
    }
    .one-cont {
      float: left;
      width: 100%;
      display: flex;
      f//lex-direction: column;
      span {
        display: block;
        height: 32px;
        margin-left: 4px;
      }
      .one-yuan {
        font-size: 20px;
        color: rgba(89, 89, 89, 1);
        padding: 30px;
        width: 50%;
        float: left;
      }
      .one-money {
        font-size: 32px;
        color: red;
        padding: 30px;
         float: left;
      }
    }
  }
}
.card_header {
  position: relative;
  .totalInfo {
    position: absolute;
    top: 50px;
    right: 20px;
    span {
      font-size: 18px;
      margin-right: 18px;
      i {
        color: #e83030;
      }
    }
  }
}
.el-card {
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
</style>
